import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

interface ChurnConditionsFilterProps {
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

const churnConditions = [
  { id: 'no_active_subscription', name: 'No Current Active Subscription' },
  { id: 'no_active_package', name: 'No Current Active Package' },
  { id: 'no_charges', name: 'No Charges' },
  { id: 'not_client', name: 'Not Currently a Client' },
  { id: 'not_group_member', name: 'Not Currently a Group Member' },
  { id: 'no_visits', name: 'No Booked or Scheduled Visits' },
];

export const ChurnConditionsFilter: React.FC<ChurnConditionsFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) => churnConditions.find((option) => option.id === v)?.name || ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) =>
      churnConditions.find((option) => option.id === v) || { id: v, name: v }
  );

  return (
    <Autocomplete
      multiple
      options={churnConditions}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? churnConditions.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Churn Conditions"
        />
      )}
      renderTags={(value: readonly any[], getTagProps) =>
        value.map((option: any, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              label={typeof option === 'string' ? option : option.name}
              key={key}
              {...tagProps}
            />
          );
        })
      }
    />
  );
};
